module.exports = __webpack_public_path__ + "static/media/landingBg_old2.f9fe4979.jpg";